module.exports = __webpack_public_path__ + "img/小雪.fc79379a.png";